import _isEmpty from "lodash/isEmpty";
import _flatten from "lodash/flatten";

import { getCurrentDateTimeUtc } from "@/utils/helpers";

const state = {
    featuredBookinsight: {},
    freeBookInsights: [],
    genres: [],
    isGenresLoading: false,
    recentlyAddedInsights: []
};

const mutations = {
    SET_GENRES(state, genres = []) {
        state.genres = genres;
    },
    SET_GENRES_LOADING_STATUS(state, isGenresLoading = false) {
        state.isGenresLoading = isGenresLoading;
    },
    SET_FEATURED_BOOK_INSIGHT(state, featuredBookinsight = {}) {
        state.featuredBookinsight = featuredBookinsight;
    },
    SET_FREE_BOOK_INSIGHTS(state, freeBookInsights = []) {
        state.freeBookInsights = freeBookInsights;
    },
    SET_RECENTLY_ADDED_INSIGHTS(state, recentlyAddedInsights = []) {
        state.recentlyAddedInsights = recentlyAddedInsights;
    }
};

const actions = {
    setGenres({ commit }, genres = []) {
        commit("SET_GENRES", genres);
    },
    setGenresLoadingStatus({ commit }, isGenresLoading = false) {
        commit("SET_GENRES_LOADING_STATUS", isGenresLoading);
    },
    setFeaturedBookinsight({ commit }, featuredBookinsight = {}) {
        commit("SET_FEATURED_BOOK_INSIGHT", featuredBookinsight);
    },
    setFreeBookInsights({ commit }, freeBookInsights = []) {
        commit("SET_FREE_BOOK_INSIGHTS", freeBookInsights);
    },
    setRecentlyAddedInsights({ commit }, recentlyAddedInsights = []) {
        commit("SET_RECENTLY_ADDED_INSIGHTS", recentlyAddedInsights);
    },
    // eslint-disable-next-line
    getPreviews({ }, params = '') {
        return axiosCms.get(`/site/book-insight-previews${params}`)
    },
    updateFreeBookInsights({ dispatch }, params = "") {
        return new Promise((resolve) => {
            const freeBookInsights = dispatch("getPreviews", params);
            freeBookInsights.then(({ data }) => {
                if (data.length) {
                    dispatch("setFreeBookInsights", data);
                }
                resolve(data);
            }).catch(() => resolve([]));
        });
    },

    updateRecentlyAddedInsights({ dispatch }, params = "") {
        return new Promise((resolve) => {
            const recentlyAddedBookInsights = dispatch("getPreviews", params);
            recentlyAddedBookInsights.then(({ data }) => {
                if (data.length) {
                    dispatch("setRecentlyAddedInsights", data);
                }
                resolve(data);
            }).catch(() => resolve([]));
        });
    },
    updateFeaturedBookinsight({ dispatch }) {
        return new Promise((resolve) => {
            axiosCms.get(`/site/book-insights?q=(featured_at~null,featured_at<${getCurrentDateTimeUtc()}&sort=featured_at|desc&limit=1`).then(({ data }) => {
                if (data.length) {
                    dispatch("setFeaturedBookinsight", data[0]);
                }
                resolve();
            }).catch(() => resolve());
        });
    },
    getGenresPreviews({ dispatch }, genres = []) {
        return new Promise((resolve) => {
            const genresPromises = genres.map((genre) => dispatch("getPreviews", `?q=(genre:${genre.id})`));
            Promise.all(genresPromises).then((response) => {
                resolve(response);
            });
        });
    },
    formatGenresPreviews({ dispatch }, { genres, genresDirectory }) {

        return new Promise((resolve) => {
            dispatch("getGenresPreviews", genres).then((genresPreviewsResponses) => {
                const genresWithPreviews = [...genres];

                const genresPromisesData = _flatten(genresPreviewsResponses.map(response => response.data));

                for (const preview of genresPromisesData) {
                    const genreIndex = genresDirectory[preview.genre];
                    genresWithPreviews[genreIndex].bookInsights.push(preview);
                }
                resolve(genresWithPreviews);
            }).catch(() => resolve([]))
        });
    },
    async updateGenres({ dispatch }, { genres, genresDirectory }) {
        const formatedGenres = await dispatch("formatGenresPreviews", { genres, genresDirectory });
        if (formatedGenres.length) {
            await dispatch("setGenres", formatedGenres);
        }
        return formatedGenres;
    }
};

const getters = {
    genresLoadingStatus(state) {
        return state.isGenresLoading;
    },
    isEmptyDiscover(state) {
        return _isEmpty(state.featuredBookinsight) ||
        _isEmpty(state.freeBookInsights) ||
        _isEmpty(state.genres) ||
        _isEmpty(state.recentlyAddedInsights);
    },
    featuredInsightIsEmpty(state) {
        return !_isEmpty(state.featuredBookinsight);
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
